import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import { compose } from 'redux';
import injectReducer from 'redux-utils/injectReducer';
import injectSaga from 'redux-utils/injectSaga';

import reducer from 'containers/User/reducer';
import saga from 'containers/User/saga';

import { converter } from 'helpers/converter';
import { removeModal } from 'actions/response';
import { actionUserModify } from 'containers/User/actions';
import FormValidations from 'data/FormValidations';
import InputText from 'containers/_Shared/Input/InputText';
import { getModifyStatus } from 'containers/User/selectors/Modify';

import './modalCompleteInfo.scss';

class ModalCompleteInfo extends React.Component {
  state = {
    statusEmail: '',
    useOther: false,
    button: false,
    form: {
      email: {
        value: '',
        error: false,
        msg: '',
      },
      firstname: {
        value: '',
        error: false,
        msg: '',
      },
      lastname: {
        value: '',
        error: false,
        msg: '',
      },
    },
    errors: {},
  };

  UNSAFE_componentWillMount() {
    const form = Object.assign({}, this.state.form);
    form.firstname.value = this.props.user.firstname;
    form.lastname.value = this.props.user.lastname;
    this.setState({ form });
  }

  UNSAFE_componentWillReceiveProps = nextProps => {
    if (nextProps.statusEmail) {
      if (nextProps.statusEmail.status === '0') {
        this.closeModal();
      } else {
        const form = Object.assign({}, this.state.form);
        form.email.error = true;
        form.email.msg = nextProps.statusEmail.msg;
        this.setState({ form, button: false });
      }
    }
  };

  isValidForm = () => {
    let formValid = true;
    const form = Object.assign({}, this.state.form);
    const errors = {};
    let button = true;
    form.email.error = false;

    Object.assign(
      errors,
      new FormValidations(form.email.value, 'email')
        .validateEmailFormat(
          converter.convertApaUnicode(
            this.props.translations,
            'registro_valido_mail',
            'Ingresa un email valido.',
          ),
        )
        .getErrors(),
    );

    if (Object.keys(errors).length !== 0) {
      form.email.error = true;
      form.email.msg = errors.email;
      formValid = false;
      button = false;
    }

    this.setState({ errors, form, button });
    return formValid;
  };

  changeState = e => {
    const form = Object.assign({}, this.state.form);
    form[e.target.name].value = e.target.value;
    this.setState({ form });
  };

  handleSendForm = e => {
    e.preventDefault();
    if (!this.isValidForm()) {
      return;
    }
    const payload = {
      email: this.state.form.email.value,
      lastname: this.state.form.lastname.value,
      firstname: this.state.form.firstname.value,
      user_hash: this.props.user.userhash,
    };

    this.props.onUserModify(payload);
  };

  closeModal = () => {
    this.props.closeModal('CompleteInfo');
  };

  render() {
    const { translations } = this.props;

    return (
      <Modal show className="form form-complete-info" style={{ zIndex: 1030 }}>
        <Modal.Header>
          <h4 className="text-center">
            {converter.convertApaUnicode(
              translations,
              'sso_complete_personal_data_title',
            )}
          </h4>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div>
            <InputText
              placeholder={converter.convertApaUnicode(
                translations,
                'sso_complete_personal_data_email_placeholder',
              )}
              maxLength={50}
              name="email"
              changeState={this.changeState}
              value={this.state.form.email.value}
              error={this.state.form.email.error}
              errorMsg={this.state.form.email.msg}
            />
          </div>
          <div>
            <InputText
              placeholder={converter.convertApaUnicode(
                translations,
                'sso_complete_personal_data_name_placeholder',
              )}
              maxLength={50}
              name="firstname"
              changeState={this.changeState}
              value={this.state.form.firstname.value}
            />
          </div>
          <div>
            <InputText
              placeholder={converter.convertApaUnicode(
                translations,
                'sso_complete_personal_data_lastname_placeholder',
              )}
              maxLength={50}
              name="lastname"
              changeState={this.changeState}
              value={this.state.form.lastname.value}
            />
          </div>
          <div className="text">
            <label>
              {converter.convertApaUnicode(
                translations,
                'sso_mandatory_email_disclaimer',
              )}
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="col-xs-12 padding-top-05 text-center">
            <p>
              <button
                type="button"
                className="btn"
                onClick={this.handleSendForm}
                disabled={this.state.button}
              >
                {converter.convertApaUnicode(translations, 'sso_continune_btn')}
              </button>
            </p>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  statusEmail: getModifyStatus(state),
  translations: state.translations,
  user: state.user,
});

const mapDispatchToProps = dispatch => ({
  onUserModify: payload => dispatch(actionUserModify(payload)),
  closeModal: modalType => dispatch(removeModal(modalType)),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: 'sso', reducer });
const withSaga = injectSaga({ key: 'sso', saga });

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(ModalCompleteInfo);
